import { Routes } from '@angular/router';
import { PagesComponent } from './pages.component';
import type { HomeComponent } from './home/home.component';
import type { QuestionAnswerComponent } from './question-answer/question-answer.component';

export const pagesRoutes: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./home/home.component').then((m: { HomeComponent: typeof HomeComponent }) => m.HomeComponent),
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./home/home.component').then((m: { HomeComponent: typeof HomeComponent }) => m.HomeComponent),
      },
      {
        path: 'question-answer',
        loadComponent: () =>
          import('./question-answer/question-answer.component').then(
            (m: { QuestionAnswerComponent: typeof QuestionAnswerComponent }) => m.QuestionAnswerComponent,
          ),
      },
      {
        path: 'password-change-confirmation',
        loadComponent: () =>
          import('./question-answer/question-answer.component').then(
            (m: { QuestionAnswerComponent: typeof QuestionAnswerComponent }) => m.QuestionAnswerComponent,
          ),
      },
    ],
  },
];
